// export component
import { ComponentClass } from 'react';
export { ComponentClass };
import { LightningProps } from 'owa-lightning-v2';
import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';

import { launchDomainConnectSetAlias } from './orchestrator/launchCreateEmailFromPopout';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "OwaMailDomainConnect" */ './lazyIndex')
);

export let PremiumDomainConnectFirstStepLightable = createLazyComponent(
    lazyModule,
    m => m.DomainConnectFirstStepLightable
);
export let PremiumDomainConnectFirstStep = createLazyComponent(
    lazyModule,
    m => m.DomainConnectFirstStep
);
export let PremiumDomainConnectSecondStep = createLazyComponent(
    lazyModule,
    m => m.DomainConnectSecondStep
);
export { LightningProps };
export { initializeDomainConnectRoutes } from './routing/domainConnectRoutes';
export let lazyMountAndShowDCSecondStep = new LazyAction(
    lazyModule,
    m => m.mountAndShowDCSecondStep
);

export { domainConnectFetchDomainService } from './services/domainConnectFetchDomain';
export { DomainConnectFetchSetupResponse } from './contract/DomainConnectFetchSetupResponse';

export const HMPlusBit = 2;

if (typeof window !== 'undefined' && typeof window.Owa !== 'undefined') {
    (<any>window).Owa.launchDomainConnectSetAlias = launchDomainConnectSetAlias;
}

export { SapiErrorCodes } from './utils/sapiErrorCode';
